import { useRef, useState, useEffect } from 'react';

const useDropdown = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      const isClickOutside = ref =>
        ref.current && !ref.current.contains(event.target);
      if (isClickOutside(dropdownRef) && isClickOutside(buttonRef)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef, buttonRef]);

  return { dropdownRef, buttonRef, showDropdown, setShowDropdown };
};

export default useDropdown;
